module.exports = __webpack_public_path__ + "static/media/star.43ccefcc.svg";